/**
 * Storage for the double-submit CSRF token issued alongside login/refresh
 * (see backend/src/middleware/csrf.js for why this exists). Kept as a tiny
 * standalone module — rather than living on the Redux auth slice — so both
 * authSlice.ts and privateClient.ts (which cannot import the store without
 * a circular dependency) can read/write it directly.
 */

const CSRF_TOKEN_KEY = "csrfToken";
const REFRESH_TOKEN_KEY = "refreshToken";

/** Header name the backend's requireCsrfToken middleware reads (see backend/src/middleware/csrf.js). */
export const CSRF_HEADER_NAME = "X-CSRF-Token";

/**
 * Header the backend reads the refresh token off of (see
 * backend/src/modules/auth/controllers/authController.js readRefreshToken).
 * The refresh token is no longer an ambient SameSite=None cookie — that is a
 * third-party cookie relative to this app's origin and gets dropped by
 * Safari/Firefox ITP, Chrome's third-party-cookie restrictions, and any
 * browser over plain http://localhost. It now travels in the login/refresh
 * response body and is sent back explicitly on this header instead.
 */
export const REFRESH_HEADER_NAME = "X-Refresh-Token";

export function getCsrfToken(): string | null {
  return localStorage.getItem(CSRF_TOKEN_KEY);
}

export function setCsrfToken(token: string): void {
  localStorage.setItem(CSRF_TOKEN_KEY, token);
}

export function clearCsrfToken(): void {
  localStorage.removeItem(CSRF_TOKEN_KEY);
}

export function getRefreshToken(): string | null {
  return localStorage.getItem(REFRESH_TOKEN_KEY);
}

export function setRefreshToken(token: string): void {
  localStorage.setItem(REFRESH_TOKEN_KEY, token);
}

export function clearRefreshToken(): void {
  localStorage.removeItem(REFRESH_TOKEN_KEY);
}
